import { render } from "./CookieBanner.vue?vue&type=template&id=3a4706a9&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"

import "./CookieBanner.vue?vue&type=style&index=0&id=3a4706a9&scoped=true&lang=css"

import exportComponent from "/Users/yourkesa/Downloads/qron_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4706a9"]])

export default __exports__